import { Box, Stack, Typography } from '@mui/material';
import { ReactNode } from 'react';

export const StatCard = ({
  icon,
  title,
  value,
  subtitle,
}: {
  icon: ReactNode;
  title: string;
  value: number;
  subtitle: string;
}) => (
  <Box
    display="flex"
    alignItems="center"
    flexGrow={1}
    p={2}
    gap={2}
    sx={(theme) => ({
      border: `1px solid ${theme.palette.border.main}`,
      borderRadius: 2,
    })}
  >
    {icon}
    <Stack>
      <Typography variant="body1" fontWeight="bold">
        {value} {title}
      </Typography>
      <Typography variant="body2">{subtitle}</Typography>
    </Stack>
  </Box>
);
